import { Injectable } from '@angular/core';
import {SessionDetails} from '../api';

export interface VersionInfo {
  display: string;
  build: string;
  raw: string;
  major: string;
  minor: string;
  majorMinor: string;
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private session: SessionDetails = {user: undefined};

  constructor() { }

  public getSession(): SessionDetails {
    return this.session;
  }

  public setSession(session: SessionDetails) {
    this.session = session;
  }

  public getVersionInfo(): VersionInfo {
    const raw = this.session.version ?? '';
    const [major = '', minor = '', build = ''] = raw.split('.');
    return {
      display: `${major}.${minor} (${build})`,
      build,
      raw,
      major,
      minor,
      majorMinor: `${major}.${minor}`
    };
  }

}
